import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingDock from "@/components/common/FloatingDock";
import CookieConsent from "@/components/common/CookieConsent";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingDock />
      <CookieConsent />
    </div>
  );
}
